import styled from 'styled-components'

import { Infos as GSInfos } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { borderWidths, colors, fontSizes, media, radii, space } = theme

export const MythList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};

  @media (${media.tablet}) {
    flex-direction: row;
  }
`

export const Infos = styled(GSInfos)`
  @media (${media.tablet}) {
    p:last-of-type {
      margin-bottom: ${space['spacing-xl']};
    }
  }
`

export const Card = styled.div`
  width: 100%;
  padding: ${space['spacing-md']};
  border: ${borderWidths['border-stroke-micro']} solid ${colors['neutral-border-default']};
  border-radius: ${radii['corner-radius-md']};
  background-color: ${colors['neutral-background-default']};

  h3 {
    margin-bottom: 14px;
  }

  > p:not(:last-of-type) {
    margin-bottom: ${space['spacing-sm']};
  }

  @media (${media.desktop}) {
    h3 {
      font-size: ${fontSizes['font-size-heading-5']};
    }
  }
`

export const ImageMobWrapper = styled.div`
  width: calc(100% + ${space['spacing-xxl']});
  margin-left: -${space['spacing-md']};
  margin-bottom: ${space['spacing-md']};
  padding: 0 ${space['spacing-md']};

  @media (${media.tablet}) {
    display: none;
  }
`

export const ImageMob = styled.div`
  position: relative;
`
